<template>
  <div class="wameed-dashboard-page-content">


    <page-header
        :title="$t('reviews.title')"
        :subTitle="$t('reviews.subtitle')"
    >
      <template v-slot:btns>
        <div class="outline-link" @click="exportReviewsToExcel">
          <o-export-icon/>
          {{ $t('common.export_excel') }}
        </div>
      </template>
    </page-header>

    <div>
      <filter-header
          :content="filterContent"
          @applyFilter="applyFilter"
          @resetFilter="resetFilter"
          @orderApplicants="orderData"

          :searchPlaceholder="$t('common.search') + ' ...'"
          :btnTitle="$t('common.filter_data')"
          :menuTitle="$t('common.order_by') + ' : '"
          :subTitle="'asdf'"
          :orderByItems=" [
        {
          name: this.$i18n.t('common.newest'),
          id: 'desc',
        },
        {
          name: this.$i18n.t('common.older'),
          id: 'asc',
        }
      ]"
      />
    </div>
    <section
        class="
        wameed-dashboard-page-content_body
        d-flex
        flex-column
        justify-content-between
        overflow-hidden
      ">
      <div class="d-flex flex-wrap flex-1 ">
        <b-col lg="12" md="12" class="px-0">

          <div class="w-table">
            <w-tables
                :noDataTitle="$t('table.no_data_title')"
                :noDataSubtitle="$t('table.no_data_subtitle')"
                v-if="getData"
                :per-page="filterData.per_page"
                :page-number="filterData.page"
                :items="getData"
                :fields="tableFields"
                :custimized-items="[
                { name: 'rated_at' },
                { name: 'publish' },
                { name: 'comment' },
                { name: 'vendor' },
                { name: 'rate' },
                { name: 'action' },
              ]"
            >

              <template slot="rate" slot-scope="{ data }">
                <customer-rate :rate="data.item.rate"/>
              </template>

              <template slot="vendor" slot-scope="{ data }">
                <check-value :value="data.item.vendor"/>
              </template>

              <template slot="comment" slot-scope="{ data }">
                <check-value :value="data.item.comment"/>
              </template>

              <template slot="publish" slot-scope="{ data }">
                <wameed-switch
                    :checked="data.item.publish ===1"
                    @onChange="(e)=>{e.preventDefault();onChange(data.item)}"/>
              </template>

              <template slot="rated_at" slot-scope="{ data }">
                {{ formatDate(data.item.rated_at, 'YYYY-MM-DD') }}
              </template>

              <template slot="action" slot-scope="{ data }">
                <b-dropdown

                    v-permission="[$route.meta.pagePermissions.readOrder]"
                    variant="background"
                    class="table-option"
                    toggle-class="text-decoration-none rounded-10 px-2 py-2 "
                    menu-class="rounded-8"
                    no-caret
                    dropleft
                >
                  <template v-slot:button-content>
                    <vertical-dots-icon/>
                  </template>


                  <b-dropdown-item
                      :to="goToDetail(data.item.id)"
                  >
                    <span class="text-regular-14 text-font-secondary permission-show-detail">
                      <eyeon-icon class="mx-2"/>
                      {{ $t('common.show_details') }}
                    </span>
                  </b-dropdown-item>


                </b-dropdown>
              </template>
            </w-tables>
          </div>

        </b-col>

        <b-col lg="12" md="12" class="px-0">
          <wameed-pagination
              v-if="getTotal"
              v-model="filterData.page"
              :page="filterData.page"
              :total-items="getTotal.totalItems"
              :per_page="filterData.per_page"
              :menu-title="$t('common.show_results')"
              @changePage="changePage"
              @changeCurrentPage="changeCurrentPage"
          />
        </b-col>

      </div>

    </section>

    <warning-modal
        variant="main"
        iconName="o-toggle-icon"
        :visible="showModal"
        @close="showModal = false"
        @submitAction="toggleAction"
        :title="modal.title"
        :subTitle="modal.subTitle"
        :btnTitle="modal.btn"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import PageHeader from '@/components/wameed/WameedPageHeader.vue';
import {WameedPagination, WameedSwitch, WameedTables as WTables} from 'wameed-ui/dist/wameed-ui.esm'
import GeneralStatusBadge from "@/components/generalStatusBadge";
import CheckValue from "@/components/checkValue";
import WarningModal from "@/components/WarningModal";
import FilterHeader from "@/components/wameed/WameedFilterHeader";
import CustomerRate from "@/components/customerRate";

export default {
  components: {

    GeneralStatusBadge,

    CustomerRate,
    CheckValue,
    WarningModal,
    PageHeader,
    FilterHeader,
    WameedPagination,
    WameedSwitch,
    WTables,

  },
  data() {
    return {
      showModal: false,
      modal: {
        title: this.$i18n.t('toggle.inactive.title'),
        subTitle: this.$i18n.t('toggle.inactive.sub_title'),
        btn: this.$i18n.t('toggle.inactive.btn'),
      },
      toggleData: {id: 0, publish: 0},
      currentItemData: null,
      filterData: {
        status: '',
        page: 1,
        per_page: 20,
        order_by: 'desc',
        search: '',
      },
      filterContent: [
        {
          title: this.$i18n.t('common.status'),
          key: 'status',
          id: 'id',
          name: 'title',
          type: 'text',
          selectedData: [],
          translate: true,
          data: [
            {
              id: 'active',
              title: this.$i18n.t('status.active'),
            },
            {
              id: 'not_active',
              title: this.$i18n.t('status.not_available'),
            },
          ],
        },
        {
          title: this.$i18n.t('filters.stars'),
          key: 'stars',
          id: 'id',
          name: 'title',
          selectedData: [],
          type: 'stars',
          data: [

            {
              id: 1,
              title: 1,
            },
            {
              id: 2,
              title: 2,
            },
            {
              id: 3,
              title: 3,
            },
            {
              id: 4,
              title: 4,
            },
            {
              id: 5,
              title: 5,
            },
          ]
        },
      ],

      tableFields: [
        {
          key: "index",
          label: "#",
          sortable: true,
        },

        {
          key: 'no',
          label: this.$i18n.t('table.order.no'),
          sortable: false,
          tdClass: 'w-2/8'
        },

        {
          key: 'rated_at',
          label: this.$i18n.t('table.rated_at'),
          sortable: false,
          tdClass: 'w-1/8'
        },

        {
          key: 'service',
          label: this.$i18n.t('table.service_type'),
          sortable: false,
          tdClass: 'w-1/8'
        },

        {
          key: 'vendor',
          label: this.$i18n.t('table.vendor'),
          sortable: false,
          tdClass: 'w-1/8'
        },
        {
          key: 'driver',
          label: this.$i18n.t('table.driver'),
          sortable: false,
          tdClass: 'w-1/8'
        },

        {
          key: 'rate',
          label: this.$i18n.t('table.rate'),
          sortable: false,
          tdClass: 'w-1/8'
        },
        {
          key: 'comment',
          label: this.$i18n.t('table.comment'),
          sortable: false,
          tdClass: 'w-1/8'
        },
        {
          key: 'publish',
          label: this.$i18n.t('common.status'),
          sortable: false,
          tdClass: 'w-1/8'
        },
        {
          key: 'action',
          label: this.$i18n.t('table.options'),
          tdClass: 'w-1/8'
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getData: 'reviews/getData',
      getTotal: 'reviews/getTotal',
    }),
  },
  created() {
    this.loadData();
  },
  methods: {


    exportReviewsToExcel() {
      this.$store.dispatch('reviews/exportExcel', {type: 'reviews'})
    },
    onChange(item) {
      let publish = 1;
      if (item.publish === 1) {
        this.modal = {
          title: this.$i18n.t('toggle.inactive.title'),
          subTitle: this.$i18n.t('toggle.inactive.sub_title'),
          btn: this.$i18n.t('toggle.inactive.btn'),
        }
        publish = 0;
      } else {
        this.modal = {
          title: this.$i18n.t('toggle.active.title'),
          subTitle: this.$i18n.t('toggle.active.sub_title'),
          btn: this.$i18n.t('toggle.active.btn'),
        }

      }
      this.toggleData = {id: item.review_id, publish: publish};
      this.showModal = true;
    },

    toggleAction() {
      this.$store.dispatch('reviews/toggle', this.toggleData)
      this.showModal = false;
    },
    changeCurrentPage(item) {
      this.filterData = {
        ...this.filterData,
        per_page: item.id,
        page: 1,
      };
      this.loadData();
    },

    changePage(event) {
      this.filterData = {
        ...this.filterData,
        page: event,
      };
      this.loadData();
    },

    loadData() {
      this.$store.dispatch('reviews/get', this.filterData)
    },


    goToDetail(id) {
      return {
        name: 'reviews-detail',
        params: {lang: this.$i18n.locale, id},
      };
    },

    applyFilter() {
      this.filterContent.forEach(item => {
        this.filterData[item.key] = item.selectedData.toString();
      });
      this.loadData();
    },


    resetFilter() {
      this.filterContent.forEach((item, i) => {
        this.filterContent[i].selectedData = [];
        this.filterData[item.key] = item.selectedData.toString();
      });
      this.loadData();
    },


    orderData(item) {
      this.filterData = {
        ...this.filterData,
        ...item,
      };
      this.loadData();
    },
  },
};
</script>

